import type { Type } from '.';

export function SitePermissions(config?: Type.SitePermissions): Type.SitePermissions {
	return config ?? [];
}
